import get from 'api/get'
import { basicAuthCredentials, currentUser } from 'helpers/globals'
import configuredAxios from 'api/config'

/** Called when initializing projects */
export function getBasicAuthCredentials(axios) {
  return get({ url: basicAuthCredentials, axios: axios || configuredAxios, opts: { 'axios-retry': { retries: 3 } } })
}

/** Get current information from logged in user */
export function getCurrentUser(axios) {
  return get({ url: currentUser, axios: axios || configuredAxios, opts: { 'axios-retry': { retries: 4 } } })
}



// WEBPACK FOOTER //
// ./src/api/authentication.js